export type NodeColor = 'neutral' | 'sky' | 'emerald' | 'amber' | 'violet'

export const NODE_COLOR_OPTIONS: NodeColor[] = ['neutral', 'sky', 'emerald', 'amber', 'violet']

/** RGB values for each color (for use in rgba() backgrounds) */
export const NODE_COLOR_RGB: Record<NodeColor, string> = {
  neutral: '115, 115, 115',  // neutral-500
  sky: '14, 165, 233',       // sky-500
  emerald: '16, 185, 129',   // emerald-500
  amber: '245, 158, 11',     // amber-500
  violet: '139, 92, 246',    // violet-500
}

export function getNodeColorClasses(color?: NodeColor) {
  switch (color) {
    case 'sky':
      return {
        bar: 'bg-sky-500',
        ring: 'ring-sky-500/50',
        border: 'border-sky-500',
        rgb: NODE_COLOR_RGB.sky,
      }
    case 'emerald':
      return {
        bar: 'bg-emerald-500',
        ring: 'ring-emerald-500/50',
        border: 'border-emerald-500',
        rgb: NODE_COLOR_RGB.emerald,
      }
    case 'amber':
      return {
        bar: 'bg-amber-500',
        ring: 'ring-amber-500/50',
        border: 'border-amber-500',
        rgb: NODE_COLOR_RGB.amber,
      }
    case 'violet':
      return {
        bar: 'bg-violet-500',
        ring: 'ring-violet-500/50',
        border: 'border-violet-500',
        rgb: NODE_COLOR_RGB.violet,
      }
    case 'neutral':
    default:
      return {
        bar: 'bg-neutral-500',
        ring: 'ring-neutral-500/40',
        border: 'border-neutral-500',
        rgb: NODE_COLOR_RGB.neutral,
      }
  }
}
